import { authRequest } from './api/auth';

class PreferenceService {
    getWebPush() {
        return authRequest.get(`/preference/?code=WEB_PUSH`);
    }
    preferenceList() {
        return authRequest.get(`/preference/admin/`);
    }
    createPreference(data) {
        return authRequest.post(`/preference/admin/`, data);
    }
    editPreference(data) {
        return authRequest.put(`/preference/admin/${data.id}/`, data);
    }
    deletePreference(id) {
        return authRequest.delete(`/preference/admin/${id}/`);
    }
    getUpChat() {
        return authRequest.get(`/preference/?code=UPCHAT`);
    }
    getEmailSync() {
        return authRequest.get(`/preference/?code=EMAIL_SYNC`);
    }
    getSmsVendor() {
        return authRequest.get(`/preference/?code=SMS_VENDOR`);
    }
    update(code,data) {
        return authRequest.put(`/preference/?code=${code}`,data);
    }
    getOpenAI() {
        return authRequest.get(`/preference/?code=OPENAI`);
    }
    getApiKey() {
        return authRequest.get(`/preference/?code=API_ACCESS_KEY`);
    }
    getUPGPT_COPILOT() {
        return authRequest.get(`/preference/?code=UPGPT_COPILOT`);
    }
    getUPGPT() {
        return authRequest.get(`/preference/?code=UPGPT`);
    }
    getINDUSTRY() {
        return authRequest.get(`/preference/?code=INDUSTRY`);
    }
    getCUSTOM_DATA() {
        return authRequest.get(`/preference/?code=CUSTOM_DATA`);
    }
    getUPGPTSetting() {
        return authRequest.get(`/preference/?code=UPGPT_SETTING`);
    }
    getUPGPTMenuLogo() {
        return authRequest.get(`/preference/?code=UPGPT_MENU_LOGO`);
    }
    isADFSLogin() {
        return authRequest.get(`/preference/?code=AUTH_TYPE`);
    }
    getMaxThreadUploadFile() {
        return authRequest.get(`/preference/?code=MAX_THREAD_UPLOAD_FILE`);
    }
    enableDocumentAgent() {
        return authRequest.get(`/preference/?code=ENABLE_DOCUMENT_AGENT`);
	}
    getUPCHAT() {
        return authRequest.get(`/preference/?code=UPCHAT`);
    }
    getPrivateKnowledge(){
        return authRequest.get(`/preference/?code=PRIVATE_KNOWLEDGE`);
    }
    getPortalColorSetting(){
        return authRequest.get(`/preference/?code=PORTAL_COLORS`);
    }
    getPortalDisableCopy(){
        return authRequest.get(`/preference/?code=PORTAL_DISABLE_COPY`);
    }
    getVectorSearch() {
        return authRequest.get(`/preference/?code=VECTOR_SEARCH`);
    }
    getOnPrem() {
        return authRequest.get(`/preference/?code=ONPREM`);
    }
    getWebSearch() {
        return authRequest.get(`/preference/?code=WEB_SEARCH`);
    }
    updateWebSearch(data) {
        return authRequest.put(`/preference/?code=WEB_SEARCH`, data);
    }
    getLoginPageSetting(){
        return authRequest.get(`/preference/login-page-setting/`);
    }
    saveLoginPageSetting(formData){
        return authRequest.post(`/preference/login-page-setting/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }
    getPropertySelection() {
        return authRequest.get(`/preference/?code=PROPERTY_SELECTION`);
    }
    getUploadRedirect() {
        return authRequest.get(`/preference/?code=UPGPT_UPLOAD_REDIRECT`);
    }
    getKnowledgeOpenNewTab() {
        return authRequest.get(`/preference/?code=KNOWLEDGE_OPEN_NEW_TAB`);
    }

}

export default new PreferenceService();
